webpackJsonp([257340023865929],{

/***/ 787:
/***/ (function(module, exports) {

	module.exports = {
	  "key": "view-libraries",
	  "name": "View Libraries",
	  "description": "View libraries render your app in the browser. You provide some code or data in a format that is specific to the library, and the library handles rendering DOM elements and styles. All of these run within the browser, but some also run on the server.",
	  "aka": [
	    "UX Libraries",
	    "UX Frameworks"
	  ],
	  "tags": [
	    {
	      "name": "mobile",
	      "description": "Renders native views on iOS/Android instead of browser DOM elements."
	    }
	  ],
	  "articles": [],
	  "projects": [
	    {
	      "githubPath": "hyperapp/hyperapp",
	      "description": "1 kB JavaScript framework for building web applications.",
	      "homepage": "https://hyperapp.js.org",
	      "dependencies": null,
	      "tags": [],
	      "lastStarCount": 14862,
	      "lastUpdatedAt": "2018-07-27T21:18:43Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/25238911?v=4"
	    },
	    {
	      "githubPath": "facebook/react",
	      "description": "A declarative, efficient, and flexible JavaScript library for building user interfaces.",
	      "homepage": "https://reactjs.org",
	      "dependencies": null,
	      "tags": [],
	      "lastStarCount": 107410,
	      "lastUpdatedAt": "2018-07-27T21:02:48Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/69631?v=4"
	    },
	    {
	      "githubPath": "developit/preact",
	      "description": "⚛️ Fast 3kB React alternative with the same modern API. Components & Virtual DOM.",
	      "homepage": "https://preactjs.com",
	      "dependencies": null,
	      "tags": [],
	      "lastStarCount": 19522,
	      "lastUpdatedAt": "2018-07-27T17:54:15Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/105127?v=4"
	    },
	    {
	      "githubPath": "angular/angular",
	      "description": "One framework. Mobile & desktop.",
	      "homepage": "https://angular.io",
	      "dependencies": null,
	      "tags": [],
	      "lastStarCount": 38935,
	      "lastUpdatedAt": "2018-07-27T21:11:33Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/139426?v=4"
	    },
	    {
	      "githubPath": "MithrilJS/mithril.js",
	      "description": "A Javascript Framework for Building Brilliant Applications",
	      "homepage": "http://mithril.js.org",
	      "dependencies": null,
	      "tags": [],
	      "lastStarCount": 8829,
	      "lastUpdatedAt": "2018-07-27T15:53:21Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/19475707?v=4"
	    },
	    {
	      "githubPath": "elm/compiler",
	      "description": "Compiler for Elm, a functional language for reliable webapps.",
	      "homepage": "http://elm-lang.org/",
	      "dependencies": null,
	      "tags": [],
	      "lastStarCount": 4594,
	      "lastUpdatedAt": "2018-07-27T17:03:53Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/20698192?v=4"
	    },
	    {
	      "githubPath": "facebook/react-native",
	      "description": "A framework for building native apps with React.",
	      "homepage": "https://facebook.github.io/react-native/",
	      "dependencies": null,
	      "tags": [
	        "mobile"
	      ],
	      "lastStarCount": 66838,
	      "lastUpdatedAt": "2018-07-27T21:18:21Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/69631?v=4"
	    },
	    {
	      "githubPath": "OnsenUI/OnsenUI",
	      "description": "Mobile app development framework and SDK using HTML5 and JavaScript. Create beautiful and performant cross-platform mobile apps. Based on Web Components, and provides bindings for Angular 1, 2, React and Vue.js.",
	      "homepage": "https://onsen.io/",
	      "dependencies": null,
	      "tags": [],
	      "lastStarCount": 6597,
	      "lastUpdatedAt": "2018-07-27T09:32:03Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/5972822?v=4"
	    },
	    {
	      "githubPath": "emberjs/ember.js",
	      "description": "Ember.js - A JavaScript framework for creating ambitious web applications",
	      "homepage": "http://www.emberjs.com",
	      "dependencies": null,
	      "tags": [],
	      "lastStarCount": 19242,
	      "lastUpdatedAt": "2018-07-27T19:43:16Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/1253363?v=4"
	    },
	    {
	      "githubPath": "vuejs/vue",
	      "description": "🖖 A progressive, incrementally-adoptable JavaScript framework for building UI on the web.",
	      "homepage": "http://vuejs.org",
	      "dependencies": null,
	      "tags": [],
	      "lastStarCount": 108923,
	      "lastUpdatedAt": "2018-07-27T21:05:01Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/6128107?v=4"
	    },
	    {
	      "githubPath": "NativeScript/NativeScript",
	      "description": "NativeScript is an open source framework for building truly native mobile apps with JavaScript. Use web skills, like Angular, FlexBox and CSS, and get native UI and performance on iOS and Android.",
	      "homepage": "https://www.nativescript.org",
	      "dependencies": null,
	      "tags": [
	        "mobile"
	      ],
	      "lastStarCount": 14268,
	      "lastUpdatedAt": "2018-07-27T20:02:44Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/7392261?v=4"
	    }
	  ]
	}

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _viewLibraries = __webpack_require__(787);
	
	var _viewLibraries2 = _interopRequireDefault(_viewLibraries);
	
	var _Page = __webpack_require__(10);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _ListPageContainer = __webpack_require__(18);
	
	var _ListPageContainer2 = _interopRequireDefault(_ListPageContainer);
	
	var _StyledTextBlock = __webpack_require__(15);
	
	var _StyledTextBlock2 = _interopRequireDefault(_StyledTextBlock);
	
	var _addNotes = __webpack_require__(43);
	
	var _addNotes2 = _interopRequireDefault(_addNotes);
	
	var _Link = __webpack_require__(34);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var extendedList = (0, _addNotes2.default)(_viewLibraries2.default, {
	  "elm-lang/elm-compiler": "This is actually a language created specifically for creating webapps. This is not technically a JavaScript tool, but it compiles to JavaScript.",
	  "facebook/react-native": "This one doesn't actually run in the browser or create webapps. It helps you create views in iOS and Android apps.",
	  "facebook/react": _react2.default.createElement(
	    _StyledTextBlock2.default,
	    null,
	    "Also check out the React-specific lists:",
	    " ",
	    _react2.default.createElement(
	      _Link2.default,
	      { to: "/react-tutorials" },
	      "tutorials"
	    ),
	    ",",
	    " ",
	    _react2.default.createElement(
	      _Link2.default,
	      { to: "/react-starter-projects" },
	      "starter projects"
	    ),
	    ",",
	    " ",
	    _react2.default.createElement(
	      _Link2.default,
	      { to: "/react-example-apps" },
	      "example apps"
	    ),
	    ", and",
	    " ",
	    _react2.default.createElement(
	      _Link2.default,
	      { to: "/react-components" },
	      "components"
	    ),
	    "."
	  )
	});
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _Page2.default,
	    null,
	    _react2.default.createElement(
	      _ListPageContainer2.default,
	      { list: extendedList },
	      _react2.default.createElement(
	        _StyledTextBlock2.default,
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          "View libraries render your app in the browser. You provide some code or data in a format that is specific to the library, and the library handles rendering your DOM elements."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "The more traditional alternative to a view library is server templates. Templates work well when the DOM doesn't change much in the browser."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "View libraries become essential when your frontend has a high degree of interactivity. Using a view library creates an abstraction layer between your code and the DOM. This can often lead to simpler, more maintainable code."
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-list-view-libraries-js-8fda852cb860bb690a39.js